import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Box, IconButton, Stack } from '@mui/material'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'

export const PureCarousel: React.FC<React.PropsWithChildren<{}>> = ({
  children,
}) => {
  const carouselRef = useRef<HTMLDivElement>(null)
  const [isChildrenOverflowing, setIsChildrenOverflowing] =
    useState<boolean>(false)

  // Function to get carousel and children widths
  const getWidths = useCallback(() => {
    if (carouselRef.current) {
      const carouselWidth = carouselRef.current.offsetWidth
      const carouselScrollWidth = carouselRef.current.scrollWidth

      if (carouselWidth < carouselScrollWidth) {
        if (!isChildrenOverflowing) setIsChildrenOverflowing(true)
      } else {
        if (isChildrenOverflowing) setIsChildrenOverflowing(false)
      }
    }
  }, [isChildrenOverflowing])

  // Log widths when component mounts, updates, or window resizes
  useEffect(() => {
    getWidths()

    const handleResize = () => {
      getWidths()
    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [getWidths])

  return (
    <Box sx={{ position: 'relative' }}>
      <Stack
        direction="row"
        gap={2}
        sx={{
          scrollSnapType: 'x mandatory',
          overflowX: 'scroll',
          scrollbarWidth: 'none',
          mx: isChildrenOverflowing ? 5 : 0,
        }}
        ref={carouselRef}
      >
        {children}
      </Stack>
      {isChildrenOverflowing && (
        <>
          <IconButton
            className="tw-top-1/2 -tw-translate-y-1/2 tw-left-0"
            style={{ position: 'absolute' }}
            onClick={() => {
              carouselRef.current.scrollBy({ left: -100, behavior: 'smooth' })
            }}
          >
            <ChevronLeftIcon fontSize="small" />
          </IconButton>
          <IconButton
            className="tw-top-1/2 -tw-translate-y-1/2 tw-right-0"
            style={{ position: 'absolute' }}
            onClick={() => {
              carouselRef.current.scrollBy({ left: 100, behavior: 'smooth' })
            }}
          >
            <ChevronRightIcon fontSize="small" />
          </IconButton>
        </>
      )}
    </Box>
  )
}
